import { useEffect, useState } from "react";
import OtpInput from "../../../../components/auth/OtpInput";
import Button from "../../../../components/auth/Button";
import { requestOtp, verifyOtp } from "../../../../api/restaurantAuth";

const RESEND_COOLDOWN_SECONDS = 60;

export default function OtpStep({ phone, isNewUser, rememberMe, onRememberMeChange, onVerified, onEditPhone }) {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [seconds, setSeconds] = useState(RESEND_COOLDOWN_SECONDS);

  useEffect(() => {
    if (seconds <= 0) return undefined;
    const timer = setInterval(() => setSeconds((prev) => prev - 1), 1000);
    return () => clearInterval(timer);
  }, [seconds]);

  const handleVerify = async (event) => {
    event?.preventDefault();
    const code = otp.join("");
    if (code.length !== 6) {
      setError("کد ۶ رقمی را کامل وارد کنید.");
      return;
    }

    try {
      setLoading(true);
      setError("");
      const data = await verifyOtp(phone, code, rememberMe);
      onVerified(data);
    } catch (err) {
      setError(err.response?.data?.error?.message || "کد وارد شده صحیح نیست.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      setResending(true);
      setError("");
      await requestOtp(phone);
      setOtp(["", "", "", "", "", ""]);
      setSeconds(RESEND_COOLDOWN_SECONDS);
      setNotice("کد جدید ارسال شد.");
      setTimeout(() => setNotice(""), 4000);
    } catch (err) {
      setError(err.response?.data?.error?.message || "ارسال مجدد کد با خطا مواجه شد.");
    } finally {
      setResending(false);
    }
  };

  return (
    <form onSubmit={handleVerify} className="space-y-6">
      <div className="text-center">
        <p className="text-sm leading-7 text-gray-500">
          کد ۶ رقمی ارسال شده به شماره زیر را وارد کنید
          {isNewUser ? " تا ثبت‌نام را تکمیل کنید." : " تا وارد پنل خود شوید."}
        </p>
        <div className="mt-2 flex items-center justify-center gap-2">
          <span dir="ltr" className="font-semibold text-accent">{phone}</span>
          <button type="button" onClick={onEditPhone} className="rounded-md px-1 py-0.5 text-xs text-primary underline underline-offset-4 transition-colors hover:text-[#d86412] focus:outline-none focus:ring-2 focus:ring-primary/20">
            ویرایش شماره
          </button>
        </div>
      </div>

      <OtpInput value={otp} onChange={(value) => { setOtp(value); setError(""); }} />

      <label className="flex items-center justify-center gap-2 text-sm text-gray-600">
        <input
          type="checkbox"
          checked={rememberMe}
          onChange={(event) => onRememberMeChange(event.target.checked)}
          className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary/30"
        />
        مرا به خاطر بسپار
      </label>

      {error && <p role="alert" className="text-center text-xs leading-5 text-red-600">{error}</p>}
      {notice && <p role="status" className="text-center text-xs leading-5 text-secondary">{notice}</p>}

      <Button type="submit" loading={loading} loadingText="در حال بررسی...">
        تایید کد
      </Button>

      <div className="text-center text-sm">
        {seconds > 0 ? (
          <span role="timer" className="text-gray-400">ارسال مجدد کد تا {seconds} ثانیه دیگر</span>
        ) : (
          <button
            type="button"
            onClick={handleResend}
            disabled={resending}
            className="rounded-lg px-2 py-1 font-semibold text-primary transition-colors hover:text-[#d86412] focus:outline-none focus:ring-2 focus:ring-primary/20 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {resending ? "در حال ارسال..." : "ارسال مجدد کد"}
          </button>
        )}
      </div>
    </form>
  );
}
